export function normalizeOrganizations(list) {
  if (!Array.isArray(list)) return [];
  return list
    .filter((org) => org && org.id != null)
    .map((org) => ({
      id: org.id,
      name: String(org.name || '').trim() || `Organization ${org.id}`,
      is_primary: Boolean(org.is_primary),
      is_active: Boolean(org.is_active),
      is_organization_admin: Boolean(org.is_organization_admin),
      roles: Array.isArray(org.roles) ? org.roles : [],
    }));
}

export function getActiveOrganizationId(user) {
  if (!user || typeof user !== 'object') return null;
  const id =
    user.active_organization_id
    ?? user.organization_id
    ?? user.primary_organization_id
    ?? null;
  return id != null && id !== '' ? id : null;
}

export function getPrimaryOrganization(organizations) {
  if (!Array.isArray(organizations) || organizations.length === 0) return null;
  return organizations.find((org) => org.is_primary) || organizations[0];
}

export function getActiveOrganization(organizations, user) {
  if (!Array.isArray(organizations) || organizations.length === 0) return null;
  const activeId = getActiveOrganizationId(user);
  if (activeId != null) {
    const match = organizations.find((org) => String(org.id) === String(activeId));
    if (match) return match;
  }
  return organizations.find((org) => org.is_active) || organizations[0];
}

export function mergeUserWithOrganizations(user, organizations, overrides = {}) {
  const base = user && typeof user === 'object' ? { ...user, ...overrides } : { ...overrides };
  const normalizedOrgs = normalizeOrganizations(organizations);

  const activeId =
    base.active_organization_id
    ?? base.organization_id
    ?? normalizedOrgs.find((org) => org.is_active)?.id
    ?? base.primary_organization_id
    ?? normalizedOrgs[0]?.id
    ?? null;

  const primaryId =
    base.primary_organization_id
    ?? normalizedOrgs.find((org) => org.is_primary)?.id
    ?? null;

  const orgsWithFlags = normalizedOrgs.map((org) => ({
    ...org,
    is_active: activeId != null && String(org.id) === String(activeId),
    is_primary: primaryId != null && String(org.id) === String(primaryId),
  }));

  const activeOrg = orgsWithFlags.find((org) => org.is_active) || orgsWithFlags[0];

  return {
    ...base,
    organizations: orgsWithFlags,
    active_organization_id: activeId,
    organization_id: activeId,
    primary_organization_id: primaryId,
    is_organization_admin:
      base.is_organization_admin ?? activeOrg?.is_organization_admin ?? false,
  };
}

export function mergeUserFromAuthPayload(data) {
  if (!data || typeof data !== 'object') return null;
  const nested = data.data && typeof data.data === 'object' ? data.data : null;
  const user = data.user || nested?.user || (data.id ? data : null);
  if (!user) return null;

  const organizations =
    data.organizations
    ?? nested?.organizations
    ?? user.organizations
    ?? [];

  return mergeUserWithOrganizations(user, organizations);
}
